import type { ArrendamentoResumo } from '../schemas';
import { ImovelDetailContent } from './ImovelDetailModal';

import { imoveisDoContrato } from './arrendamento-imoveis-helpers';

export function ArrendamentoImoveis({ arrendamento }: { arrendamento: ArrendamentoResumo }) {
  const imoveis = imoveisDoContrato(arrendamento);
  return (
    <div className="mt-4 pt-4 border-t border-border">
      <h3 className="text-sm font-semibold">Detalhes dos Imóveis Arrendados</h3>
      {imoveis.length > 1 && (
        <p className="text-xs text-text-muted my-2">
          Imóveis individualizados por matrícula. Área contratada e pagamentos são conjuntos,
          contabilizados uma única vez no contrato.
        </p>
      )}
      {imoveis.map((im) => (
        <section key={String(im.id)} className="mt-4 pt-4 border-t border-border">
          <h4 className="text-sm font-semibold">{String(im.denominacao || 'Imóvel arrendado')}</h4>
          <p className="text-xs text-text-muted">Matrícula {String(im.matricula || 'pendente')}</p>
          <ImovelDetailContent imovel={im} cpfDono={null} nomeDono={arrendamento.arrendador_nome ?? null} />
        </section>
      ))}
    </div>
  );
}
